<div class="task-check" (click)="toggleStatus()"
  [class.task-check--done]="status == 'done'">
  <span class="icon icon-check-circle"></span>
</div>
